export class AssessmentStoreModel {
    assessmentTypeId: number = null;
    assessmentDate: Date = null;
    assessmentUrl?: string = null;
    overallScoreId?: number = null;
    reviewerOrganizationId: number = null;
    reviewerId: number = null;
    reviewerComments?: string = null;
}
